import React from 'react';
import { bool, func, shape, string } from 'prop-types';
import { compose } from 'redux';
import { Form as FinalForm } from 'react-final-form';
import classNames from 'classnames';

// Import configs and util modules
import { intlShape, injectIntl, FormattedMessage } from '../../../../util/reactIntl';
import { LISTING_STATE_DRAFT, propTypes } from '../../../../util/types';

// Import shared components
import { Form, Button, FieldTextInput } from '../../../../components';

// Import modules from this directory
import css from './EditListingTermsOfSaleForm.module.css';
import {
  originalOwners,
  originalReceipts,
} from '../../../../config/configSearch';
import FieldMultiSelect from '../../../../components/FieldMultiSelect/FieldMultiSelect';
import { yearFormatValid } from '../../../../util/validators';

export const EditListingTermsOfSaleFormComponent = props => (
  <FinalForm
    {...props}
    render={formRenderProps => {
      const {
        className,
        disabled,
        ready,
        handleSubmit,
        intl,
        invalid,
        pristine,
        saveActionMsg,
        updated,
        updateInProgress,
        fetchErrors,
        values,
        setSaveAsDraft,
        saveAsDraft,
        onSaveDraft,
        history
      } = formRenderProps;

      const yearValid = yearFormatValid(
        intl.formatMessage({
          id: 'EditListingAppearanceForm.yearValid',
        })
      );

      const addressRequiredMessage = intl.formatMessage({
        id: 'EditListingLocationForm.addressRequired',
      });
      const addressNotRecognizedMessage = intl.formatMessage({
        id: 'EditListingLocationForm.addressNotRecognized',
      });

      const optionalText = intl.formatMessage({
        id: 'EditListingLocationForm.optionalText',
      });

      const { updateListingError, showListingsError } = fetchErrors || {};

      const classes = classNames(css.root, className);
      const submitReady = (updated && pristine) || ready;
      const submitInProgress = updateInProgress && !saveAsDraft;;
      const submitDisabled =
        invalid ||
        disabled ||
        submitInProgress ||
        !values.originalOwner ||
        !values.originalReceipt ||
        !values.allowNegotiation;

      const saveDraftFunction = () => {
        const {
          originalOwner,
          originalReceipt,
          allowNegotiation
        } = values;
        const updateValues = {
          publicData: {
            originalOwner,
            originalReceipt,
            allowNegotiation,
            updatedAt: Math.floor(Date.now() / 1000),
          },
        };
        return onSaveDraft(updateValues)
      };

      return (
        <Form className={classes} onSubmit={handleSubmit}>
          {updateListingError ? (
            <p className={css.error}>
              <FormattedMessage id="EditListingLocationForm.updateFailed" />
            </p>
          ) : null}

          {showListingsError ? (
            <p className={css.error}>
              <FormattedMessage id="EditListingLocationForm.showListingFailed" />
            </p>
          ) : null}

          <div className={css.fieldSelect}>


            <div>
              <label><FormattedMessage id="EditListingTermsOfSaleForm.originalOwner" /></label>
              <FieldMultiSelect
                isMulti={false}
                isRequired={true}
                className={css.input}
                id={'originalOwner'}
                name={'originalOwner'}
                fontClass={css.fontClass}
                options={originalOwners}
                autoComplete={'originalOwner'}
                defaultValue={values?.style || ''}
              // validate={subCategoryRequired}
              />
            </div>
            <div>
              <label><FormattedMessage id="EditListingTermsOfSaleForm.originalReceipt" /></label>
              <FieldMultiSelect
                isMulti={false}
                isRequired={true}
                className={css.input}
                id={'originalReceipt'}
                name={'originalReceipt'}
                fontClass={css.fontClass}
                options={originalReceipts}
                autoComplete={'originalReceipt'}
                defaultValue={values?.style || ''}
              // validate={subCategoryRequired}
              />
            </div>
          </div>

          <FieldTextInput
            id="purchasedYear"
            name="purchasedYear"
            label={intl.formatMessage({ id: 'EditListingAppearanceForm.purchasedYear' })}
            validate={yearValid}
            className={css.fieldPurchasedSelect}
          />

          <br />
          <br />
          <br />
          {!(values.originalOwner && values.originalReceipt && values.allowNegotiation) && (
            <span className={css.error}>
              <FormattedMessage id="EditListingTermsOfSaleForm.errorText" values={{ TabName: <b>Terms of Sale</b> }} />
            </span>
          )}
          <div className={css.buttonContainer}>
            <Button
              className={css.submitButton}
              type="submit"
              inProgress={submitInProgress}
              disabled={submitDisabled}
              ready={submitReady}
            >
              {saveActionMsg}
            </Button>

            <Button
              className={css.draftButton}
              type="button"
              inProgress={saveAsDraft}
              disabled={submitDisabled}
              onClick={() => {
                setSaveAsDraft(LISTING_STATE_DRAFT);
                saveDraftFunction().then((res) => {
                  history.push('/listings')
                  setSaveAsDraft(null)
                })
              }}
            >
              <FormattedMessage id="EditListingDeliveryForm.saveAsDraft" />
            </Button>
          </div>
        </Form>
      );
    }}
  />
);

EditListingTermsOfSaleFormComponent.defaultProps = {
  selectedPlace: null,
  fetchErrors: null,
  formId: 'EditListingTermsOfSaleForm',
};

EditListingTermsOfSaleFormComponent.propTypes = {
  formId: string,
  intl: intlShape.isRequired,
  onSubmit: func.isRequired,
  saveActionMsg: string.isRequired,
  selectedPlace: propTypes.place,
  disabled: bool.isRequired,
  ready: bool.isRequired,
  updated: bool.isRequired,
  updateInProgress: bool.isRequired,
  fetchErrors: shape({
    showListingsError: propTypes.error,
    updateListingError: propTypes.error,
  }),
};

export default compose(injectIntl)(EditListingTermsOfSaleFormComponent);
